// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"966d0700","498":"12698ef4","513":"1a009dcb"}[chunkId] + ".chunk.js";
};